import {
  MartialStatusListResponseDTO,
  ProfessionalCategoryListResponseDTO,
  ProfessionListResponseDTO,
  GenerateTokenInputDTO,
  GenerateTokenResponseDTO,
  DireitoAcessoInputDTO,
  ResidenceTypeListResponseDTO,
  DocumentTypeListResponseDTO,
  AddressListResponseDTO,
  FlagsListResponseDTO,
  BenefitsListResponseDTO,
  ExisteRegistroUnicoResponseDTO,
  ValidateTokenRequestDTO
} from "@repo/core/services/entities/Common";
import {
  getConsultarLayoutBandeirasParams,
  hasLayoutBandeirasProduct
} from "@repo/core/utils/layoutBandeiras.utils";
import { AxiosInstance, AxiosResponse } from "axios";

const resourcePrefix = "/Comuns";

export class CommonResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  validateToken(
    payload: ValidateTokenRequestDTO
  ): Promise<AxiosResponse<boolean>> {
    const parsePayload = {
      strToken: payload.strToken,
      strCliente: `${payload.strCliente}1`,
      strFormaEnvio: payload.strFormaEnvio
    };
    return this.apiProvider.get(`${resourcePrefix}/ValidarToken`, {
      params: parsePayload
    });
  }

  generateToken(
    payload: GenerateTokenInputDTO
  ): Promise<AxiosResponse<GenerateTokenResponseDTO>> {
    return this.apiProvider.post(`${resourcePrefix}/GerarToken`, payload);
  }

  // get /Comuns/DireitoAcesso
  direitoAcesso(
    params: DireitoAcessoInputDTO
  ): Promise<AxiosResponse<boolean>> {
    return this.apiProvider.get(`${resourcePrefix}/DireitoAcesso`, {
      params
    });
  }

  // get /Comuns/DireitoAcesso
  existUnicoRecord(
    strCliente: string
  ): Promise<AxiosResponse<ExisteRegistroUnicoResponseDTO>> {
    // NOTE: We need to add the 1 to the string to avoid false positives.
    return this.apiProvider.get(
      `${resourcePrefix}/ExisteRegistroUnico?strCliente=${strCliente}1`
    );
  }

  fetchFlags(
    strProduto?: string | null
  ): Promise<AxiosResponse<FlagsListResponseDTO[]>> {
    if (!hasLayoutBandeirasProduct(strProduto)) {
      return Promise.reject(
        new Error("ConsultarLayoutBandeiras requires strProduto")
      );
    }

    return this.apiProvider.get(`${resourcePrefix}/ConsultarLayoutBandeiras`, {
      params: getConsultarLayoutBandeirasParams(strProduto)
    });
  }

  fetchMartialStatus(): Promise<AxiosResponse<MartialStatusListResponseDTO>> {
    return this.apiProvider.get(`${resourcePrefix}/ConsultarEstadosCivis`);
  }

  fetchProfessions(): Promise<AxiosResponse<ProfessionListResponseDTO>> {
    return this.apiProvider.get(`${resourcePrefix}/ConsultarProfissoes`);
  }

  fetchProfessionalCategories(): Promise<
    AxiosResponse<ProfessionalCategoryListResponseDTO>
  > {
    return this.apiProvider.get(
      `${resourcePrefix}/ConsultarClasseProfissional`
    );
  }

  fetchResidenceTypes(): Promise<
    AxiosResponse<ResidenceTypeListResponseDTO[]>
  > {
    return this.apiProvider.get(`${resourcePrefix}/ConsultarTipoResidencia`);
  }

  fetchDocumentTypes(): Promise<AxiosResponse<DocumentTypeListResponseDTO[]>> {
    return this.apiProvider.get(`${resourcePrefix}/ConsultarTiposDocumentos`);
  }

  // get /Comuns/ConsultarEndereco
  fetchAddressByCEP(
    cep: string
  ): Promise<AxiosResponse<AddressListResponseDTO>> {
    return this.apiProvider.get(`${resourcePrefix}/ConsultarEndereco`, {
      params: {
        strCep: cep
      }
    });
  }

  fetchBenefitsList(
    strProduto: string
  ): Promise<AxiosResponse<BenefitsListResponseDTO[]>> {
    return this.apiProvider.get(`${resourcePrefix}/ConsultarBeneficios`, {
      params: {
        strProduto
      }
    });
  }
}
